import { cn } from "@/lib/utils";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";

export type RichtextProps = SliceComponentProps<Content.RichtextSlice> & {
  context?: {
    richtextVariant?: "default" | "richtext";
  };
};

const Richtext = ({ slice, context }: RichtextProps) => {
  const variant = context?.richtextVariant || "default";

  return (
    <section
      data-slice-type={slice.slice_type}
      className={cn(
        "prose prose-h2:mb-5 prose-h5:mb-5 prose-li:font-medium prose-li:text-dark-primary prose-li:marker:text-dark-primary prose-h6:mb-5 prose-h4:mb-5 prose-h3:mb-5 prose-h2:mt-0 prose-h4:mt-0 prose-h5:mt-0 prose-h6:mt-0 prose-h3:mt-0 prose-p:mb-5 max-w-none space-y-5 [&_p>img]:max-h-[550px] [&_p>img]:w-full [&_p>img]:rounded-md [&_p>img]:object-cover",
        variant === "richtext" && "border-primary-light mx-7.5 border-y pt-5"
      )}
      data-slice-variation={slice.variation}
    >
      <PrismicRichText
        field={slice.primary.content}
        components={{
          heading2: ({ children }) => (
            <h2 className="font-cabinet-grotesk leading-h1 text-2xl font-medium lg:text-3xl">{children}</h2>
          ),
          paragraph: ({ children }) => (
            <p
              className={cn(
                "text-primary-light max-w-none text-sm leading-5 tracking-[0%]",
                variant === "richtext" && "text-primary-dark text-base leading-6"
              )}
            >
              {children}
            </p>
          ),
          strong: ({ children }) => (
            <strong className="text-dark-primary text-sm leading-5 font-semibold">{children}</strong>
          ),
        }}
      />
    </section>
  );
};

export default Richtext;
